import { useQueryClient, useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../../../../actions/notificationAction';
import { t13s } from '../../../../translationKeys/index';
import bulkCreateExtensions from '../services/bulkCreateExtensions';

interface Props {
  orderInvoices: number[];
  type: string;
  expirationDate: Date | undefined;
  feeAmount: number | undefined;
  startDate: Date | undefined;
  baseRate: number | undefined;
  justification: string;
  linkDocuments: string;
}

const useBulkCreateExtensions = (onSuccessAction: () => void) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const {
    isLoading,
    isError,
    data,
    mutate: createExtensions,
    reset: resetDataAndErrors,
  } = useMutation((params: Props) => bulkCreateExtensions(params), {
    onMutate: async () => {
      await queryClient.cancelQueries('getPayerById', {
        exact: false,
      });
      const prevDataByPayer = queryClient.getQueryData('getPayerById', {
        exact: false,
      });
      return prevDataByPayer;
    },
    onError: (_err, _variables, context: unknown) => {
      dispatch(
        enqueueSnackbar(t13s.ERROR.ERROR_CREATE_BULK_EXTENSIONS, {
          variant: 'error',
        })
      );
      queryClient.setQueryData('getPayerById', (context as any).data);
    },
    onSettled: () => {
      queryClient.invalidateQueries('getPayerById', {
        exact: false,
      });
    },
    onSuccess: () => {
      dispatch(
        enqueueSnackbar(t13s.NOTIFICATION.COLLECTION_EXTENSION_BULK_CREATED, {
          variant: 'success',
        })
      );
      onSuccessAction();
    },
  });

  return {
    isLoading,
    isError,
    data,
    createExtensions,
    resetDataAndErrors,
  };
};

export default useBulkCreateExtensions;
